/**
 * @description Textbox measurement UI 요소의 텍스트 박스 스타리 정의
 */

///
/// 글꼴 정의(크기, 색, 글꼴)
///
let defaultFontSize = 14,
  defaultFont = `${defaultFontSize}px NanumGothic Regular`,
  defaultFontFamily = "NanumGothic Regular",
  //defaultFont = `${defaultFontSize}px dotum Regular`,
  defaultFontColor = "#fff",
  defaultBackgroundColor = "#2b2b2b7f",
  defaultStrokeColor = "#0000007f";
//defaultBackgroundColor = "transparent";

function setFont(font) {
  defaultFont = font;
}

function getFont() {
  return defaultFont;
}

function getFontFamily() {
  return defaultFontFamily;
}

function setFontSize(fontSize) {
  defaultFontSize = fontSize;
}

function getFontSize() {
  return defaultFontSize;
}

function setBackgroundColor(backgroundColor) {
  defaultBackgroundColor = backgroundColor;
}

function getBackgroundColor() {
  return defaultBackgroundColor;
}

function setFontColor(fontColor) {
  defaultFontColor = fontColor;
}

function getFontColor() {
  return defaultFontColor;
}

function getStrokeColor() {
  return defaultStrokeColor;
}

const textStyle = {
  setFont,
  getFont,
  getFontFamily,
  setFontSize,
  getFontSize,
  setFontColor,
  getFontColor,
  setBackgroundColor,
  getBackgroundColor,
  getStrokeColor
};

export default textStyle;
